var hidden, visibilityChange;
var callback = () => { };
if (typeof document.hidden !== "undefined") {
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
  hidden = "msHidden";
  visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}
function handleVisibilityChange() {
  callback(document[hidden]);
}

export default (func) => {
  if (func) callback = func;

  if (typeof document.addEventListener === "undefined" || typeof document[hidden] === "undefined") {
    console.log("不支持");
  } else {
    document.addEventListener(visibilityChange, handleVisibilityChange, false);
  }
}